import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: 0,
    minWidth: 0,
    rowGap: tokens.spacingVerticalS,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalS,
    flexShrink: 0,
    flexWrap: 'wrap',
    padding: 0,
  },
  documentTitle: {
    flex: 1,
    minWidth: 0,
    overflowWrap: 'anywhere',
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    marginLeft: 'auto',
  },
  description: {
    color: tokens.colorNeutralForeground3,
  },
  typeCard: {
    display: 'flex',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalXXS,
    paddingBottom: tokens.spacingVerticalXXS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground2,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusLarge,
    boxShadow: tokens.shadow2,
  },
  typeIcon: {
    color: tokens.colorBrandForeground1,
    fontSize: tokens.fontSizeBase400,
    flexShrink: 0,
  },
  typeLabel: {
    color: tokens.colorNeutralForeground2,
    whiteSpace: 'nowrap',
  },
  typeDropdown: {
    minWidth: '240px',
    // Keep the selected value on a single, slightly larger line.
    '& button': {
      whiteSpace: 'nowrap',
      fontSize: tokens.fontSizeBase300,
    },
  },
  typeListbox: {
    minWidth: '240px',
  },
  typeOption: {
    // Smaller text in the open menu than the selected value.
    fontSize: tokens.fontSizeBase200,
  },
  status: {
    color: tokens.colorNeutralForeground3,
  },
  viewerRegion: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: 0,
    minWidth: 0,
  },
  addButton: {
    color: tokens.colorNeutralForeground3,
  },
});
